import { FadeIn } from "@/components/site/FadeIn";
import { THEMES } from "@/data/book";

export const ThemesStrip = () => (
  <section
    id="themes"
    data-testid="themes-section"
    className="relative py-24 sm:py-28 bg-[#f5f2ea] border-y border-stone-200/70"
  >
    <div className="max-w-6xl mx-auto px-6">
      <FadeIn className="text-center max-w-2xl mx-auto mb-16">
        <p className="text-xs uppercase tracking-[0.28em] text-[#2a7b76] font-semibold mb-4">
          The territory within
        </p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#201c19] font-light leading-tight">
          Emotional ground the poems walk
        </h2>
      </FadeIn>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {THEMES.map((t, i) => (
          <FadeIn
            key={t.key}
            delay={i * 0.06}
            data-testid={`theme-pill-${t.key}`}
            className="group rounded-2xl bg-white/70 border border-stone-200/80 p-7 hover:border-[#2a7b76]/40 hover:bg-white transition-colors duration-300"
          >
            <div className="flex items-center gap-3 mb-3">
              <span className="h-2 w-2 rounded-full bg-[#c07a67] group-hover:bg-[#2a7b76] transition-colors" />
              <h3 className="font-display text-2xl text-[#201c19]">{t.label}</h3>
            </div>
            <p className="text-sm text-stone-500 leading-relaxed font-light">{t.note}</p>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
);

export default ThemesStrip;
